import { GLOBAL_CLIENT_ONLY_LOCALE, handleLocaleUrl } from 'dibs-intl/exports/urls';
import { getCheckoutUrl } from '../helpers/getCheckoutUrl';
import { PRERENDER_CHECKOUT_ROOT_ID } from './constants';
import {
    PrerenderedCheckoutParams,
    getPrerenderedCheckoutState,
    setPrerenderedCheckoutRootState,
} from './prerenderedCheckoutStore';
import { getCheckoutTriggerPage } from '../helpers/checkoutTrackingTyped';
import { pageDwellTracker } from 'dibs-tracking';

const SYNTHETIC_PAGE = 'SYNTHETIC_PAGE';

const runPrerenderedCheckoutDeferredActions = (): void => {
    const { deferredActions } = getPrerenderedCheckoutState();
    deferredActions.forEach(action => action());
};

const onPopState = ({ state }: PopStateEvent): void => {
    const isPageSetByHistoryApi = state === SYNTHETIC_PAGE;
    if (!isPageSetByHistoryApi) {
        return;
    }

    // if page was created with history api and opened with back/forward browser buttons
    // then we should reload page, to keep it in sync with url
    window.location.reload();
};

export const handleBrowserButtons = (): void => {
    // function can be called twice, so let's keep only 1 listener
    window.removeEventListener('popstate', onPopState);

    window.addEventListener('popstate', onPopState);
};

function getUtmQueryParams(): Record<string, string> {
    const urlParams = new URLSearchParams(window.location.search);
    return Array.from(urlParams.entries())
        .filter(([key]) => key.startsWith('utm_'))
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
}

export const redirectToPrerenderedCheckout = ({
    itemId,
    params,
    hideParentPage,
}: {
    itemId: string;
    params: PrerenderedCheckoutParams;
    hideParentPage: () => void;
}): void => {
    const utmParams = getUtmQueryParams();

    const url = getCheckoutUrl({
        itemId,
        triggerPage: getCheckoutTriggerPage(window.location.href),
        ...params,
        ...utmParams,
    });

    const { rootState } = getPrerenderedCheckoutState();
    const checkoutRootElement = window.document.getElementById(PRERENDER_CHECKOUT_ROOT_ID);

    if (rootState !== 'ENABLED_IN_BACKGROUND' || !checkoutRootElement) {
        window.location.assign(handleLocaleUrl(url, GLOBAL_CLIENT_ONLY_LOCALE));
        return;
    }

    hideParentPage();
    // Stop parent page dwell time tracker
    pageDwellTracker.stop();
    // Mark parent page as synthetic to handle back/forward browser buttons
    window.history.replaceState(SYNTHETIC_PAGE, '');
    // Mark new page as synthetic, change url
    window.history.pushState(SYNTHETIC_PAGE, '', handleLocaleUrl(url, GLOBAL_CLIENT_ONLY_LOCALE));
    /**
     * Need to remove overflow:hidden in buyer message center.
     */
    document.body.style.overflow = 'auto';
    setPrerenderedCheckoutRootState('VISIBLE');
    runPrerenderedCheckoutDeferredActions();
};
